import { useTranslation } from 'react-i18next';

import { SubHeader, withQueryState } from 'coreOld/components';
import { IFiltersProps } from 'coreOld/types';
import { RequestJobsTable } from 'support/components';
import { IRequest } from 'support/types';

interface IProps extends IFiltersProps {
  request: IRequest;
  filtersConfig: Record<string, any>;
  onEditJobsClick: () => void;
}

const RequestJobListView = ({ request, filtersConfig, onEditJobsClick }: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <SubHeader
        text={t('titleSupportRequestId', { id: request.id })}
        antentTexts={[
          t('titleTopBlockLeftSupportRequest', {
            projectName: request.projectName,
          }),
          t('titleTopBlockRightSupportRequest', {
            customerCompanyName: request?.customerCompanyName,
            customerName: request?.customerName,
          }),
        ]}
        action={onEditJobsClick}
        actionBtnText={t('buttonLabelSupportRequestEditJobs')}
        showInfoIcon
        item={request}
      />

      <RequestJobsTable filtersConfig={filtersConfig} requestId={request.id} />
    </>
  );
};

export default withQueryState(RequestJobListView);
